<template>
  <div>
    <v-container fluid class="content-wrapper">
      <v-row id="filtering-toggle">
        <v-spacer></v-spacer>
        <v-col cols="12" md="6" class="justify-center d-flex">
          <v-btn-toggle v-model="toggleControlValues" rounded mandatory>
            <v-btn value="hostingInstitution" class="btn-selected">
              Hosting Institution
            </v-btn>
            <v-btn value="providers" class="btn-selected">
              Providers
            </v-btn>
            <v-btn value="resources" class="btn-selected">
              Services & Equipment
            </v-btn>
            <v-btn value="intellectualProperties" class="btn-selected">
              Intellectual Properties
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Intellectual Properties -->
      <v-row
        justify="center"
        align="center"
        v-if="toggleControlValues == 'intellectualProperties'"
        class="mt-5"
      >
        <v-row id="filtering-toggle">
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" class="justify-center d-flex">
            <v-btn-toggle v-model="toggleIntellectualProperties" rounded mandatory>
              <v-btn value="patents" class="btn-selected">
                Patents
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-row>
      <v-row
        justify="center"
        align="center"
        v-if="
          toggleControlValues == 'intellectualProperties' &&
            toggleIntellectualProperties == 'patents'
        "
      >
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <v-tabs v-model="tabIntellectualProperties" show-arrows active-class="primary200--text">
              <v-tabs-slider color="primary200"></v-tabs-slider>
              <v-tab>{{ 'Patents Status' }}</v-tab>
              <v-tab>{{ 'Technology' }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabIntellectualProperties">
              <v-tab-item :transition="false" :reverse-transition="false" :key="'patent0'">
                <table-control-value
                  :headers="headersPatentsStatus"
                  :url-api="'/api/v1/patent-status'"
                  :default-item="item"
                  :label="'Patents Status'"
                  :sort-by="'name'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Patent Status</label>
                        <v-text-field
                          v-model="editedItem.name"
                          :placeholder="'Patents Status'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="'patent1'">
                <table-control-value
                  :headers="headersTechnology"
                  :url-api="'/api/v1/technologies'"
                  :default-item="item"
                  :label="'Technology'"
                  :sort-by="'name'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Patent Status</label>
                        <v-text-field
                          v-model="editedItem.name"
                          :placeholder="'Patents Status'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>

      <!-- Hosting Institution -->
      <v-row justify="center" align="center" v-if="toggleControlValues == 'hostingInstitution'">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <v-tabs v-model="tabHostingInstitutions" show-arrows active-class="primary200--text">
              <v-tabs-slider color="primary200"></v-tabs-slider>
              <v-tab>{{ 'Areas of Activites' }}</v-tab>
              <v-tab>{{ 'Ecosystem Stakeholder Profile' }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabHostingInstitutions">
              <v-tab-item :transition="false" :reverse-transition="false" :key="'h0'">
                <table-control-value
                  :headers="headersAreasOfActivities"
                  :url-api="'/api/v1/areas-of-activity'"
                  :default-item="item"
                  :label="'Areas of Activities'"
                  :sort-by="'name'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Areas of Activities</label>
                        <v-text-field
                          v-model="editedItem.name"
                          :placeholder="'Areas of Activities'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="'h1'">
                <table-control-value
                  :headers="headersEcosystem"
                  :url-api="'/api/v1/ecosystem-stakeholder-profile'"
                  :default-item="item"
                  :label="'Ecosystem Stakeholder Profile'"
                  :sort-by="'name'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Ecosystem Stakeholder Profile</label>
                        <v-text-field
                          v-model="editedItem.name"
                          :placeholder="'Ecosystem Stakeholder Profile'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>

      <!-- Providers -->
      <v-row justify="center" align="center" v-if="toggleControlValues == 'providers'">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <v-tabs v-model="tabProviders" show-arrows active-class="primary200--text">
              <v-tabs-slider color="primary200"></v-tabs-slider>
              <v-tab>{{ 'Scientific Domain' }}</v-tab>
              <v-tab>{{ 'Structure Type' }}</v-tab>
              <v-tab>{{ 'Areas of Activites' }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabProviders">
              <v-tab-item :transition="false" :reverse-transition="false" :key="'p0'">
                <table-control-value
                  :headers="headersScientific"
                  :url-api="'/api/v1/scientific-subdomains'"
                  :default-item="scientific"
                  :label="'Scientific Domain'"
                  :sort-by="'domain'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Scientific Domain</label>
                        <v-text-field
                          v-model="editedItem.domain"
                          :placeholder="'Scientific Domain'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <label>Scientific Subdomain</label>
                        <v-text-field
                          v-model="editedItem.subDomain"
                          :placeholder="'Scientific Subdomain'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="'p1'">
                <table-control-value
                  :headers="headersStructureType"
                  :url-api="'/api/v1/structure-types'"
                  :default-item="item"
                  :label="'Structure Type'"
                  :sort-by="'name'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Structure Type</label>
                        <v-text-field
                          v-model="editedItem.name"
                          :placeholder="'Structure Type'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="'p2'">
                <table-control-value
                  :headers="headersAreasOfActivities"
                  :url-api="'/api/v1/areas-of-activity'"
                  :default-item="item"
                  :label="'Areas of Activities'"
                  :sort-by="'name'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Areas of Activities</label>
                        <v-text-field
                          v-model="editedItem.name"
                          :placeholder="'Areas of Activities'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>

      <!-- Services and Equipment -->
      <v-row justify="center" align="center" v-if="toggleControlValues == 'resources'">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <v-tabs v-model="tabResources" show-arrows active-class="primary200--text">
              <v-tabs-slider color="primary200"></v-tabs-slider>
              <v-tab>{{ 'Category' }}</v-tab>
              <v-tab>{{ 'Access Type' }}</v-tab>
              <v-tab>{{ 'Access Mode' }}</v-tab>
              <v-tab>{{ 'Operational Mode' }}</v-tab>
              <v-tab>{{ 'Target Users' }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabResources">
              <v-tab-item :transition="false" :reverse-transition="false" :key="'r0'">
                <table-control-value
                  :headers="headersCategory"
                  :url-api="'/api/v1/subcategories'"
                  :default-item="category"
                  :label="'Category'"
                  :sort-by="'category'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Super Category</label>
                        <v-text-field
                          v-model="editedItem.superCategory"
                          :placeholder="'Super Category'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <label>Category</label>
                        <v-text-field
                          v-model="editedItem.category"
                          :placeholder="'Category'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <label>Subcategory</label>
                        <v-text-field
                          v-model="editedItem.subCategory"
                          :placeholder="'Subcategory'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="'r1'">
                <table-control-value
                  :headers="headersAccessType"
                  :url-api="'/api/v1/access-types'"
                  :default-item="item"
                  :label="'Access Type'"
                  :sort-by="'name'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Access Type</label>
                        <v-text-field
                          v-model="editedItem.name"
                          :placeholder="'Access Type'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="'r2'">
                <table-control-value
                  :headers="headersAccessMode"
                  :url-api="'/api/v1/access-modes'"
                  :default-item="item"
                  :label="'Access Mode'"
                  :sort-by="'name'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Access Mode</label>
                        <v-text-field
                          v-model="editedItem.name"
                          :placeholder="'Access Mode'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="'r3'">
                <table-control-value
                  :headers="headersOperationalMode"
                  :url-api="'/api/v1/operational-modes'"
                  :default-item="item"
                  :label="'Operational Mode'"
                  :sort-by="'name'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Operational Mode</label>
                        <v-text-field
                          v-model="editedItem.name"
                          :placeholder="'Operational Mode'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false" :key="'r4'">
                <table-control-value
                  :headers="headersTargets"
                  :url-api="'/api/v1/targets'"
                  :default-item="item"
                  :label="'Targets'"
                  :sort-by="'name'"
                >
                  <template v-slot:form="{ editedItem }">
                    <v-row>
                      <v-col cols="12">
                        <label>Target Users</label>
                        <v-text-field
                          v-model="editedItem.name"
                          :placeholder="'Target Users'"
                          outlined
                          clearable
                          :rules="requiredRule()"
                          class="required"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </table-control-value>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import base from '@/services/base-service.js';
import TableControlValue from '@/components/admin/control-values/TableControlValue';

export default {
  name: 'ControlValues',
  components: { TableControlValue },
  mixins: [util, base],
  data: () => ({
    toggleControlValues: 'provider',
    toggleIntellectualProperties: 'patents',
    tabProviders: null,
    tabResources: null,
    tabHostingInstitutions: null,
    tabIntellectualProperties: null,
    domains: [],
    categories: [],
    scientific: {
      domain: null,
      subDomain: null,
    },
    category: {
      superCategory: null,
      category: null,
      subCategory: null,
    },
    item: {
      name: null,
    },
  }),
  computed: {
    loading() {
      return this.loadingComponents !== 0;
    },
    headersScientific() {
      let headers = [
        { text: '', value: 'actions', sortable: true, width: 200 },
        { text: 'Scientific Domain', value: 'domain', sortable: true },
        { text: 'Scientific Subdomain', value: 'subDomain', sortable: true },
      ];
      return headers;
    },
    headersInstitution() {
      let headers = [
        { text: '', value: 'actions', sortable: true, width: 200 },
        { text: 'Institution', value: 'name', sortable: false },
        { text: 'Address', value: 'address', sortable: false },
        { text: 'Website', value: 'url', sortable: false },
      ];
      return headers;
    },
    headersStructureType() {
      let headers = [
        { text: '', value: 'actions', sortable: true, width: 200 },
        { text: 'Structure Type', value: 'name', sortable: false },
      ];
      return headers;
    },
    headersAreasOfActivities() {
      let headers = [
        { text: '', value: 'actions', sortable: false, width: 200 },
        { text: 'Areas of Activities', value: 'name', sortable: false },
      ];
      return headers;
    },
    headersEcosystem() {
      let headers = [
        { text: '', value: 'actions', sortable: false, width: 200 },
        { text: 'Ecosystem Stakeholder Profile', value: 'name', sortable: false },
      ];
      return headers;
    },
    headersPatentsStatus() {
      let headers = [
        { text: '', value: 'actions', sortable: false, width: 200 },
        { text: 'Patent Status', value: 'name', sortable: false },
      ];
      return headers;
    },
    headersTechnology() {
      let headers = [
        { text: '', value: 'actions', sortable: false, width: 200 },
        { text: 'Technology', value: 'name', sortable: false },
      ];
      return headers;
    },
    headersCategory() {
      let headers = [
        { text: '', value: 'actions', sortable: true, width: 200 },
        { text: 'Super Category', value: 'superCategory', sortable: true },
        { text: 'Category', value: 'category', sortable: true },
        { text: 'Subcategory', value: 'subCategory', sortable: true },
      ];
      return headers;
    },
    headersAccessType() {
      let headers = [
        { text: '', value: 'actions', sortable: true, width: 200 },
        { text: 'Access Type', value: 'name', sortable: false },
      ];
      return headers;
    },
    headersAccessMode() {
      let headers = [
        { text: '', value: 'actions', sortable: true, width: 200 },
        { text: 'Access Mode', value: 'name', sortable: false },
      ];
      return headers;
    },
    headersOperationalMode() {
      let headers = [
        { text: '', value: 'actions', sortable: true, width: 200 },
        { text: 'Operational Mode', value: 'name', sortable: false },
      ];
      return headers;
    },
    headersTargets() {
      let headers = [
        { text: '', value: 'actions', sortable: true, width: 200 },
        { text: 'Target Users', value: 'name', sortable: false },
      ];
      return headers;
    },
  },
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
